export default function useParseCssList(cssList) {
    var splitted = cssList.replace("(", "").replace(")", "").split(",")
    var result = {}
    splitted.map(str => {
        var split = str.split(":")
        result[split[0].trim()] = split[1].trim()
    })
    return result
}